<template>
  <div class="text-default truncate font-600 leading-30 text-16">
    {{ name }}
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "ListTitle"
});
</script>
<script setup>
defineProps({ name: String });
</script>
